import { render } from "./policy-alert.component.vue?vue&type=template&id=188866a2&ts=true"
import script from "./policy-alert.component.vue?vue&type=script&lang=ts"
export * from "./policy-alert.component.vue?vue&type=script&lang=ts"

import "./policy-alert.component.vue?vue&type=style&index=0&id=188866a2&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__